import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import { select, Store} from '@ngrx/store';
import {switchMap, withLatestFrom} from 'rxjs/internal/operators';
import {map} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {currentSiteActionTypes, LoadCurrentSiteAction, LoadCurrentSiteFailAction, LoadCurrentSiteSuccessAction} from '../actions/current-site';
import {error} from '../actions/toasts';
import {BaseEffect} from './base.effect';
import * as fromShared from '../reducers';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class CurrentSiteEffect extends BaseEffect {


  load$ = createEffect(() => { return this.actions$.pipe(ofType(currentSiteActionTypes.LOAD),
    map( (action: LoadCurrentSiteAction) => action.payload),
    debug('Load current site info action received.'),
    withLatestFrom(this.store.pipe(select(fromShared.selectors.getMySites))),
    switchMap(([payload, sites]) =>
        [
      new LoadCurrentSiteSuccessAction(sites.find(site => site.name === payload)),
      // new LoadMySubscriptionsSuccessAction(sites.find(site => site.name === payload).subscriptions)
    ]
    ))
  });


  loadFail$ = createEffect(() => { return this.actions$
    .pipe(ofType(currentSiteActionTypes.LOAD_FAIL),
      debug('A error occurred while loading the current site.'),
      map((action: LoadCurrentSiteFailAction) =>
        error(this.translation.translate('CURRENT_SITE_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              router: Router,
              private store: Store<fromShared.AppState>) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadCurrentSiteFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadCurrentSiteFailAction(response['error'].message);
  }
}
